import * as React from 'react'
import type { SVGProps } from 'react'
function Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      data-name="Ebene 1"
      viewBox="0 0 135.63 139.05"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="c">
        <path d="M26.69,73.76h0C11.97,73.75,0,61.79,0,47.08-.45,31.24,20.86,5.03,23.88,1.4c.65-.87,1.69-1.4,2.8-1.4s2.11.51,2.77,1.35c2.86,3.43,24.37,29.82,23.91,45.82,0,14.61-11.96,26.58-26.67,26.58h0ZM26.68,9.09c-7.36,9.45-19.97,27.81-19.68,37.89,0,10.95,8.83,19.78,19.68,19.78,10.85,0,19.68-8.83,19.68-19.68.29-10.16-12.32-28.54-19.68-37.99Z" />
        <path d="M112.68,105.71h0c-12.63,0-22.91-10.27-22.94-22.9-.34-13.57,17.6-35.64,20.15-38.72.65-.86,1.68-1.38,2.79-1.38s2.1.51,2.76,1.34c2.42,2.91,20.58,25.19,20.19,38.82,0,12.55-10.29,22.84-22.93,22.85h0ZM112.68,51.82c-6.18,8.01-16.18,22.75-15.94,30.85,0,.03,0,.07,0,.1,0,8.79,7.15,15.94,15.94,15.95,8.79,0,15.94-7.15,15.94-15.95.23-8.18-9.77-22.93-15.94-30.95Z" />
        <path d="M57.69,139.05h0c-10.97,0-19.9-8.92-19.93-19.89-.29-11.65,14.94-30.41,17.15-33.08.65-.86,1.68-1.38,2.78-1.38s2.1.5,2.75,1.33c2.08,2.5,17.48,21.4,17.19,33.12-.03,10.97-8.96,19.89-19.93,19.89h0ZM57.68,93.83c-5.92,7.76-13.11,19.2-12.94,25.18,0,.03,0,.07,0,.1,0,7.13,5.8,12.94,12.94,12.94,7.13,0,12.94-5.81,12.94-12.94,0-.03,0-.07,0-.1.17-5.98-7.02-17.43-12.94-25.18Z" />
      </g>
    </svg>
  )
}
export default Icon
